import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { USER_LOCALSTORAGE_KEY } from "shared/const/localstorage";
import {CutDataResponse} from "../../../types/student-info/studentInfoCutsShema";
import {setCutData} from "../../../slice/student-info/StudentInfoCutSlice";

interface StudentInfoParams {
    groupId: string | undefined;
    studentId: string | undefined;
}

export const fetchStudentCuts = createAsyncThunk(
    "student/fetchStudentCuts",

    async ({ groupId, studentId }: StudentInfoParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<CutDataResponse>(`/api/groups/${groupId}/student-info/${studentId}/cuts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setCutData(response.data.data.items));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
